import { render, staticRenderFns } from "./modal_anamnese_internacao.vue?vue&type=template&id=0c7d1014&scoped=true"
import script from "./modal_anamnese_internacao.vue?vue&type=script&lang=js"
export * from "./modal_anamnese_internacao.vue?vue&type=script&lang=js"
import style0 from "./modal_anamnese_internacao.vue?vue&type=style&index=0&id=0c7d1014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7d1014",
  null
  
)

export default component.exports